export function colorForMatchConfidence(conf) {
  if (conf < 0.9) {
    return 'red';
  } else if (conf < 0.97) {
    return 'yellow';
  } else {
    return 'green';
  }
};

export function confidenceformat(conf) {
  if (!conf) return ''; if (conf < 0.9) return conf.toFixed(2); if (conf < 0.99) return conf.toFixed(4); return conf.toFixed(6);
}


// WEBPACK FOOTER //
// ./src/util/confidence.js